export default "__VITE_ASSET__BY1M3Aui__"